import { makeVar } from '@apollo/client'

export const emptyAppState = {
  showSidebar: true,
  showSearchHeader: false,
}

export const appState = makeVar({
  ...emptyAppState,
})
